'use client'

import {BlogNotFound} from '@/components/blog/BlogNotFound'

// Overrides [locale]/not-found.tsx for articles - a client component for the same reason as that one.
export default function NotFound() {
  return <BlogNotFound />
}
